/**
 * get ScrollMagic.Scene props
 * @param {Object} wfProps 
 * @param {Object} setup 
 * @return {Object}
 */
export const getScrollMagicSceneProps = (el, setup) => {
  const triggerElement = getTriggerFromProps(setup, el)
  const duration = getDurationFromProps(setup)
  const offset = getOffsetFromProps(setup)
  return {
    triggerElement,
    duration,
    offset
  }
}
const getTriggerFromProps = (setup, el) => {
  let trigger = el
  if (setup.trigger) {
    switch (setup.trigger) {
      case "parent":
        trigger = el.parentNode
        break;
      default:
        trigger = setup.trigger
        break;
    }
  }
  return trigger
}
const getDurationFromProps = (setup) => {
  let duration = 0
  if (setup.duration) {
    duration = isNaN(setup.duration) ? translateNonNumericValue("duration", setup.duration) : parseFloat(setup.duration)
  }
  return duration
}
const getOffsetFromProps = (setup) => {
  const bottomOffset = setup.offset ? setup.offset : 0
  let offset
  switch (bottomOffset) {
    case "center":
      offset = 0
      break;
    case "top":
      offset = window.innerHeight * .5
      break;
    default:
      offset = bottomOffset - window.innerHeight * .5
      break;
  }
  return offset
}

/**
 * Translate non numeric value strings... 
 * @param {string} key 
 * @param {string} valStr 
 * @return {*}
 */
const translateNonNumericValue = (key, valStr) => {
  let val
  switch (key) {
    case 'duration':
      // calculate viewport vw & vh
      if (valStr.includes("vw")) {
        val = parseInt(valStr.replace("vw", "")) * .01 * window.innerWidth
      } else if (valStr.includes("vh")) {
        val = parseInt(valStr.replace("vh", "")) * .01 * window.innerHeight
      } else {
        val = valStr
      }
      break;
    default:
      // by default don't change anything (eg. '100%', '50vw')
      val = valStr
      break;
  }
  return val
}